// AUTH
export const LOGIN = "auth/login";
export const GET_DETAILS = "users/info";
export const FORGOT_PASSWORD_SEND_EMAIL = "auth/forgot-password";
export const FORGOT_PASSWORD_VERIFY_OTP = "auth/forgot-password/verify-otp";
export const FORGOT_PASSWORD_RESET = "auth/forgot-password/reset-password";
export const CHANGE_PASSWORD = "profile/change-password";
export const EDIT_PROFILE = "profile/edit";

// MEMBERSHIP
// PLAN
export const GET_MEMBERSHIP_PLANS = "membership/plan/all";
export const ADD_MEMBERSHIP_PLAN = "membership/plan/add";
export const UPDATE_MEMBERSHIP_PLAN = "membership/plan/update";
export const DELETE_MEMBERSHIP_PLAN = "membership/plan";
export const GET_MEMBERSHIP_PLAN_LIST = "membership/plan/list";
export const UPDATE_MEMBERSHIP_STATUS = "membership/plan/status";
export const GET_MEMBERSHIP_PLAN_DETAILS = "membership/plan";
// ADDONS
export const GET_ADDONS = "membership/addon/all";
export const ADD_ADDONS = "membership/addon/add";
export const UPDATE_ADDON = "membership/addon/update";
export const DELETE_ADDON = "membership/addon";
export const GET_ADDONS_LIST = "membership/addon/list";
export const UPDATE_ADDONS_STATUS = "membership/addon/status";
export const GET_ADDONS_DETAILS = "membership/addon";
// FREE WASH RULES
export const FREE_WASH_RULES = "membership/free-wash/rules";
export const UPDATE_FREE_WASH_RULES = "membership/free-wash/rules";

// USERS
export const GET_USERS = "users/all";
export const UPDATE_USER_STATUS = "users/status";
export const UPDATE_USER = "users/update";
export const GET_USER_DETAILS = "users";
export const DELETE_USER = "users";
export const ASSIGN_ROLE = "users/assign-role";
export const GET_USERS_LIST = "users/list";
export const ADD_USER = "users/add";
export const RESEND_INVITE = "users/reinvite";
export const SET_PASSWORD = "auth/set-password";
export const VERIFY_INVITE = "auth/accept-invite";
export const UPDATE_PASSWORD = "users/update-password";
export const UPDATE_MPIN = "users/set-mpin";

// ROLES
export const GET_ROLES_LIST = "roles/list";
export const GET_ROLES_PERMISSIONS = "roles/permissions";
export const ADD_ROLE = "roles/add";
export const UPDATE_ROLE = "roles/update";
export const GET_ROLE_DETAILS = "roles";
export const GET_ROLES = "roles/all";
export const UPDATE_ROLE_STATUS = "roles/status";
export const DELETE_ROLE = "roles";

// CUSTOMERS
export const GET_CUSTOMERS = "customers/all";
export const GET_CUSTOMER_DETAILS = "customers";
export const GET_CUSTOMER_VEHICLE_DETAILS = "customers/vehicles";
export const GET_CUSTOMER_TRANSACTIONS = "customers/transactions";
export const GET_CUSTOMER_MEMBERSHIPS = "customers/memberships";
export const UPDATE_CUSTOMER_STATUS = "customers/status";
export const GET_CUSTOMERS_LIST = "customers/list";

// VEHICLE MAKE
export const ADD_VEHICLE_MAKE = "vehicle/make/add"
export const GET_VEHICLE_MAKE = "vehicle/make/all"
export const GET_VEHICLE_MAKE_DETAILS = "vehicle/make"
export const UPDATE_VEHICLE_MAKE = "vehicle/make/update"
export const DELETE_VEHICLE_MAKE = "vehicle/make"
export const UPDATE_VEHICLE_MAKE_STATUS = "vehicle/make/status"
export const VEHICLE_MAKE_LIST = "vehicle/make/list"

//VEHICLE MODEL
export const GET_VEHICLE_MODEL = "vehicle/model/all"
export const ADD_VEHICLE_MODEL = "vehicle/model/add"
export const GET_VEHICLE_MODEL_DETAILS = "vehicle/model"
export const UPDATE_VEHICLE_MODEL = "vehicle/model/update"
export const DELETE_VEHICLE_MODEL = "vehicle/model"
export const UPDATE_VEHICLE_MODEL_STATUS = "vehicle/model/status"
export const VEHICLE_MODEL_LIST = "vehicle/model/list"

// VEHICLE COLOR
export const GET_VEHICLE_COLOR = "vehicle/color/all"
export const ADD_VEHICLE_COLOR = "vehicle/color/add"
export const GET_VEHICLE_COLOR_DETAILS = "vehicle/color"
export const UPDATE_VEHICLE_COLOR = "vehicle/color/update"
export const DELETE_VEHICLE_COLOR = "vehicle/color"
export const UPDATE_VEHICLE_COLOR_STATUS = "vehicle/color/status"
export const VEHICLE_COLOR_LIST = "vehicle/color/list"
// BRANCHES/STORES
export const GET_BRANCHES = "branch/all";
export const ADD_BRANCH = "branch/add";
export const UPDATE_BRANCH = "branch/update";
export const GET_BRANCH_DETAILS = "branch";
export const UPDATE_BRANCH_STATUS = "branch/status";
export const DELETE_BRANCH = "branch";
export const get_BRANCH_LIST = "branch/list";

// WASH HISTORY
export const GET_WASH_HISTORY = "wash-history/all";
export const GET_WASH_HISTORY_DETAILS = "wash-history";

// BANNERS
export const GET_BANNERS = "banners/all";
export const ADD_BANNER = "banners/add";
export const UPDATE_BANNER_STATUS = "banners/status";
export const DELETE_BANNER = "banners";
export const GET_BANNER_DETAILS = "banners";
export const UPDATE_BANNER = "banners/update";

// NOTIFICATIONS
export const BROADCAST_NOTIFICATIONS = "notifications/push/broadcast";
export const GET_NOTIFICATIONS = "notifications/push/all";
export const UPDATE_NOTIFICATION = "notifications/push/update";
export const DELETE_NOTIFICATION = "notifications/push";
export const GET_NOTIFICATION_DETAILS = "notifications/push";

// NOTIFICATIONS RULES
export const GET_NOTIFICATION_RULES = "notifications/rules/all";
export const ADD_NOTIFICATION_RULE = "notifications/rules/add";
export const UPDATE_NOTIFICATION_RULE = "notifications/rules/update";
export const UPDATE_NOTIFICATION_RULE_STATUS =
"notifications/rules/status";
export const DELETE_NOTIFICATION_RULE = "notifications/rules";
export const GET_NOTIFICATION_RULE_DETAILS = "notifications/rules";

// API LOGS
export const GET_API_LOGS = "logs/all";
export const GET_API_LOG_DETAILS = "logs";
export const API_LOGS_LIST = "logs/list";

// DASHBOARD
export const GET_DASHBOARD_DATA = "dashboard";
export const GET_DASHBOARD_DATA_RECENT_ACTIVITY = "dashboard/recent-activity";
// COUPONS 
export const GET_COUPONS = "coupons/all";
export const ADD_COUPON = "coupons/add";
export const UPDATE_COUPON_STATUS = "coupons/status";
export const DELETE_COUPON = "coupons";
export const GET_COUPON_DETAILS = "coupons";
export const UPDATE_COUPON = "coupons/update";
export const COUPONS_LIST = "coupons/list";
export const APPLIED_COUPON_HISTORY = "coupons/apply-history";


// PAGE CONTENT
export const GET_PAGE_CONTENT_BY_TYPE = 'page-content/get-by-type'
export const UPDATE_PAGE_CONTENT_BY_TYPE = 'page-content/update-by-type'
export const GET_ALL_PAGE_CONTENT = 'page-content/all'

// SYSTEM SETTINGS
export const GET_SYTSEM_SETTINGS_LIST = 'settings/list'
export const UPDATE_SYTSEM_SETTINGS = 'settings/update'

// STORE CAMERA
export const ADD_STORE_CAMERA = 'branch-camera/add';
export const UPDATE_STORE_CAMERA = 'branch-camera/update';
export const UPDATE_STORE_CAMERA_STATUS = 'branch-camera/status';
export const DELETE_STORE_CAMERA = 'branch-camera';
export const GET_STORE_CAMERA_DETAILS = 'branch-camera';
export const GET_STORE_CAMERAS = 'branch-camera/all';

// DYNAMIC PRICES
export const ADD_DYNAMIC_PRICES = 'dynamic-pricing-rules/add';
export const UPDATE_DYNAMIC_PRICES = 'dynamic-pricing-rules/update';
export const UPDATE_DYNAMIC_PRICES_STATUS = 'dynamic-pricing-rules/status';
export const GET_DYNAMIC_PRICES = 'dynamic-pricing-rules/all';
export const GET_DYNAMIC_PRICE_DETAILS = 'dynamic-pricing-rules';
export const DELETE_DYNAMIC_PRICE = 'dynamic-pricing-rules';
